import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5563e527"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col text-center" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col text-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Return To Lesson ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", {
            id: "quiz-score",
            class: _normalizeClass(["font-weight-bold", {
                            'text-success': _ctx.isGreenFont(),
                            'text-warning': _ctx.isYellowFont(),
                            'text-danger': !_ctx.isGreenFont() && !_ctx.isYellowFont()
                        }])
          }, _toDisplayString(_ctx.quizScore.toFixed(0)) + "% ", 3),
          _createElementVNode("h3", {
            style: _normalizeStyle({ color: _ctx.displayStatus.color })
          }, _toDisplayString(_ctx.displayStatus.text), 5),
          _createElementVNode("h3", null, " Quiz Score: " + _toDisplayString(_ctx.quiz.points) + "/" + _toDisplayString(_ctx.quiz.pointsPossible), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            (!_ctx.quiz.hasPerfectScore)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tryAgainClicked()))
                }, " Try Again "))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_router_link, {
            to: {
                            name: _ctx.routeNames.lesson,
                            params: {
                                courseId: _ctx.courseId,
                                lessonId: _ctx.lessonId
                            }
                        },
            class: "btn btn-secondary mt-2"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}